import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import appConfig from '../config/appConfig';

import ReceptionImg from '../assets/img/gallSlider/hiwa-reception.jpg';
import ReceptionGrid1 from '../assets/img/gallSlider/hiwa-exteriour2.jpg';
import ReceptionGrid2 from '../assets/img/restaSlider/restaurent5.jpg';
import ReceptionGrid3 from '../assets/img/gallSlider/12.jpg';
import RestoImg from '../assets/img/restaSlider/restaurent2.jpg';
import RestoGrid1 from '../assets/img/restaSlider/restaurent1.jpg';
import RestoGrid2 from '../assets/img/gallSlider/17.jpg';
import RestoGrid3 from '../assets/img/gallSlider/14.jpg';
import RoomImg from '../assets/img/gallSlider/hiwa-exteriour.jpg';
import RoomGrid1 from '../assets/img/rooms/1.jpg';
import RoomGrid2 from '../assets/img/rooms/5.jpg';
import RoomGrid3 from '../assets/img/rooms/8.jpg';

const slides = [
  {
    title: `Welcome to ${appConfig.hotel.name}`,
    subtitle: 'Reception & Hospitality',
    leftImg: ReceptionImg,
    rightImgs: [ReceptionGrid1, ReceptionGrid2, ReceptionGrid3],
  },
  {
    title: 'Dine in Style',
    subtitle: 'Our Restaurant',
    leftImg: RestoImg,
    rightImgs: [RestoGrid1, RestoGrid2, RestoGrid3],
  },
  {
    title: 'Relax in Comfort',
    subtitle: 'Room Categories',
    leftImg: RoomImg,
    rightImgs: [RoomGrid1, RoomGrid2, RoomGrid3],
  },
];

const allHeroImages = slides.flatMap((slide) => [slide.leftImg, ...slide.rightImgs]);

const HeroImage = ({ src, alt, className = '' }) => (
  <img
    src={src}
    alt={alt}
    loading="eager"
    decoding="async"
    fetchPriority="high"
    className={`transition-opacity duration-300 ${className}`}
  />
);

const HeroSlider = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    allHeroImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    // React 18 StrictMode double-mounts in dev, which can leave Swiper's
    // autoplay stopped after the second mount — force it back on.
    swiperRef.current?.autoplay?.start();
  }, []);

  return (
    <div id="home" className="flex justify-center items-center py-4 lg:py-8" style={{ background: '#FFFFE7' }}>
      <div className="w-full max-w-7xl rounded-3xl shadow-2xl bg-white/80 p-6 lg:p-10">
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          modules={[Navigation, Autoplay, EffectFade]}
          navigation
          loop
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          speed={800}
          preloadImages
          watchSlidesProgress
          className="heroSlider w-full h-[400px] lg:h-[500px] rounded-3xl"
        >
          {slides.map((slide) => (
              <SwiperSlide key={slide.subtitle} className="flex flex-col lg:flex-row h-full">
                <div className="w-full lg:w-1/2 h-full flex items-center justify-center lg:pr-4 relative">
                  <HeroImage
                    src={slide.leftImg}
                    alt={slide.subtitle}
                    className="object-cover w-full h-full rounded-2xl shadow-lg border-4 border-white"
                  />

                  <div className="absolute inset-0 flex flex-col items-center justify-end pb-8 lg:pb-12 z-10 pointer-events-none">
                    <div className="uppercase font-tertiary tracking-[4px] text-white text-sm lg:text-lg mb-2 bg-black/60 px-4 py-1 rounded-full">
                      {slide.subtitle}
                    </div>
                    <h1 className="text-xl lg:text-4xl xl:text-5xl font-primary uppercase tracking-[2px] leading-tight text-white font-bold text-center px-6 py-2 max-w-md lg:max-w-xl">
                      {slide.title}
                    </h1>
                  </div>

                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-2xl pointer-events-none" />
                </div>

                <div className="w-full lg:w-1/2 h-full flex flex-col gap-4 lg:pl-4 mt-4 lg:mt-0">
                  <div className="flex gap-4 h-1/2">
                    <div className="w-1/2 h-full overflow-hidden rounded-xl shadow-md border-2 border-white">
                      <HeroImage
                        src={slide.rightImgs[0]}
                        alt=""
                        className="object-cover w-full h-full"
                      />
                    </div>
                    <div className="w-1/2 h-full overflow-hidden rounded-xl shadow-md border-2 border-white">
                      <HeroImage
                        src={slide.rightImgs[1]}
                        alt=""
                        className="object-cover w-full h-full"
                      />
                    </div>
                  </div>

                  <div className="h-1/2 overflow-hidden rounded-xl shadow-md border-2 border-white">
                    <HeroImage
                      src={slide.rightImgs[2]}
                      alt=""
                      className="object-cover w-full h-full"
                    />
                  </div>
                </div>
              </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSlider;
